import GaugeComponent from './GaugeComponent';
export type { GaugeComponentProps, GaugeType } from './GaugeComponent/types/GaugeComponentProps';
export type { Arc, SubArc } from './GaugeComponent/types/Arc';
export type { Tooltip } from './GaugeComponent/types/Tooltip';
export type { Labels, ValueLabel } from './GaugeComponent/types/Labels';
export type { PointerContext, PointerProps, PointerRef, PointerType } from './GaugeComponent/types/Pointer';
export type { Tick, TickLabels, TickLineConfig, TickValueConfig } from './GaugeComponent/types/Tick';
export type { Angles, Dimensions, Margin } from './GaugeComponent/types/Dimensions';
export { GaugeComponent };
export default GaugeComponent;